import React from "react";
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

const LoadingSpin = ({color}) => {
  return (
    <Spin
      indicator={
        <LoadingOutlined
          style={{
            fontSize: 24,
            color: color ? color : "#b71840"
          }}
          spin
        />
      }
    />
  );
};

export default LoadingSpin;